export default __webpack_public_path__ + "static/leverOn-8dd4d7e32bddbfec9fb18fde3aae0a3e.png";